// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"a43a498d","134":"2cd139aa","237":"acb79c93","303":"25112967","453":"6b3dd8fe","458":"cd80fdb2","591":"de0d76c0","872":"a3781eeb"}[chunkId] + ".chunk.js";
};